<template>
    <div class="plan-container relative overflow-scroll">
        <img :src="plan.url" id="img-plan" alt="plan" ref="img-plan" :style="stylePlan" />
        <div v-for="device in plan.devices" :key="device.id"
             class="absolute flex items-center device" :style="{ left: `${device.plan_x}px`, top: `${device.plan_y}px` }"
             :class="[
                 (device.plan_num.value === 1 ? 'flex-row-reverse' : device.plan_num.value === 2 ? 'flex-col-reverse' : device.plan_num.value === 4 ? 'flex-col' : ''),
                 (selectedDevice !== null && selectedDevice.id === device.id ? 'selected' : '')
             ]">
            <img :src="device.current_device_type.icon" alt="picto"
                 :style="{ transform: `rotate(${device.plan_orient}deg)`, width: `${plan.plan_pictos}px`, maxWidth: `${plan.plan_pictos}px` }" />
            <span class="leading-none font-bold" style="color: #000000;"
                :class="device.plan_num.value === 1 ? 'mr-0.5' : device.plan_num.value === 2 ? '' : device.plan_num.value === 4 ? 'mt-0.5' : 'ml-0.5'"
                :style="{ fontSize: `${plan.plan_number}px` }">
                {{ device.number }}
            </span>
        </div>
        <div class="absolute" :style="{ left: `${legend.x}px`, top: `${legend.y}px` }">
            <div class="plan-legend" id="plan-legend" style="width: 200px; min-width: 200px">
                <div v-for="deviceType in plan.deviceTypes" :key="deviceType.id" class="flex items-center mb-1.5">
                    <img :src="deviceType.icon" alt="picto" style="max-width: 13px;" />
                    <span class="text-10 ml-1 leading-none">{{ deviceType.name }}</span>
                </div>
            </div>
        </div>
        <div class="absolute" :style="{ left: `${date.x}px`, top: `${date.y}px` }">
            <div class="plan-date text-xs" id="plan-date" v-html="getDate()">
            </div>
        </div>
	    <div class="absolute top-0 left-0" :style="{ width: sizePlan.width, height: sizePlan.height }" @click="handleClick"></div>
    </div>
</template>

<script>
export default {
    name: "PlanView",
    props: {
        plan: Object,
        selectedDevice: Object,
        isMobile: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data() {
        return {
            stylePlan: {
                minWidth: 'min-content',
                maxWidth: 'min-content',
                minHeight: 'min-content',
                maxHeight: 'min-content',
            },
	        sizePlan: {
				width: '',
		        height: ''
	        }
        }
    },
    computed: {
        legend() {
            return {
                x: this.plan.plan_legend_x ?? 0,
                y: this.plan.plan_legend_y ?? 0,
            }
        },
        date() {
            return {
                value: this.plan.plan_date ?? this.$moment(this.plan.updated_at).format('DD/MM/YYYY'),
                x: this.plan.plan_date_x ?? 650,
                y: this.plan.plan_date_y ?? 0,
            }
        }
    },
    methods: {
        handleClick(e) {
            const { offsetX, offsetY } = e
            this.$emit('clicked', { offsetX, offsetY })
        },
        getDate() {
            return this.date.value.replaceAll('\n', '<br>')
        },
	    setupSizePlan(planUrl) {
		    let image = new Image()
		    image.src = planUrl
		    image.onload = () => {
			    this.sizePlan.width = `${image.width}px`
			    this.sizePlan.height = `${image.height}px`
		    }
	    }
    },
	mounted() {
		if(this.plan.url) {
			this.setupSizePlan(this.plan.url)
		}
	},
	watch: {
		'plan.url'(newVal) {
			if(newVal) {
				this.setupSizePlan(newVal)
			}
		}
	}
}
</script>

<style scoped lang="scss">
.plan-container {
    border: 1px solid $body-bg;
    border-right: none;
    border-bottom: none;
    img#img-plan {
        border-right: 1px solid $body-bg;
    }
    .plan-date, .plan-legend {
        padding: 10px;
        font-weight: normal;
        line-height: 1;
        background: $body-bg;
        border-radius: 6px;

        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

        div.flex:last-child {
            margin-bottom: 0 !important;
        }
    }
    .device {
        margin-top: -7px;
        margin-left: -7px;
        padding: 5px;
        border: 2px solid transparent;
        border-radius: 3px;
        &.selected {
            border-color: $brand-primary;
        }
    }
    .text-10 {
        font-size: 10px;
    }
}
</style>
